// src/pages/TeamActivity.js — live feed across all users (orders, scans, workspaces, CRM feed, …)
import { useState, useEffect, useMemo } from "react";
import { ActivityItem } from "../components/UI";
import { watchContacts, resolveContactByUserRef } from "../lib/db";
import { watchRecentProductActivity } from "../lib/platformActivity";
import EmptyState from "../components/EmptyState";
import { History } from "lucide-react";

export default function TeamActivity({ onOpenContact }) {
  const [activity, setActivity] = useState([]);
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    return watchContacts(setContacts, () => {});
  }, []);

  useEffect(() => {
    return watchRecentProductActivity(
      setActivity,
      (err) => console.warn("[TeamActivity] activity_feed", err?.code, err?.message),
      {
        mergeCap: 220,
        perSourceLimit: 55,
        includeActivityFeed: process.env.REACT_APP_SKIP_ACTIVITY_FEED === "1" ? false : true,
      }
    );
  }, []);

  const rows = useMemo(() => {
    return activity.map((ev) => {
      const fromDoc = ev.metadata?.actorName;
      const linked = ev.contactId ? resolveContactByUserRef(contacts, ev.contactId) : null;
      const fromContact = linked?.name || null;
      const subtitle =
        fromDoc ||
        fromContact ||
        (ev.contactId ? `User ${String(ev.contactId).slice(0, 10)}…` : undefined);
      return { ev, subtitle };
    });
  }, [activity, contacts]);

  return (
    <div className="page-wrap">
      <header className="page-header">
        <h1 className="page-header-title">Team activity</h1>
        <p className="page-header-desc">{activity.length} events loaded · click a row to open the user when linked</p>
      </header>
      <div className="card" style={{ padding: 0 }}>
        <div style={{ padding: "12px 20px 20px" }}>
          {activity.length === 0 ? (
            <EmptyState
              icon={History}
              title="No activity yet"
              description="Deploy firestore.rules if you see permission-denied in the console. Set REACT_APP_SKIP_ACTIVITY_FEED=1 if only activity_feed fails."
            />
          ) : (
            rows.map(({ ev, subtitle }) => (
              <ActivityItem
                key={ev.id}
                event={ev}
                subtitle={subtitle}
                onActivate={
                  ev.contactId
                    ? () => {
                        const c = resolveContactByUserRef(contacts, ev.contactId);
                        if (c) onOpenContact(c);
                      }
                    : undefined
                }
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
}
